import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next';
import { useHistory, Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import { 
    Button,
    Box,
    Typography,
    Modal,
    Fade
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import './EnquiryStatus.scss'

import { 
    Navbar,
    Header,
    FormBox,
    Footer,
    LoadingSpinner
} from '../../components/_index'
import { useData } from '../../DataContext';
import { checkIfRedirect, isEmpty } from '../../utils';
import printJS from 'print-js';
import moment from 'moment';
import Scroll from 'react-scroll';

import { PDFDocument } from 'pdf-lib'

function downloadFile(data) {
    const blob = new Blob([data], { type: 'application/pdf' });
    const url= window.URL.createObjectURL(blob);
    //window.open(url);
    printJS({
    printable: url,
    type: 'pdf',
    })
}

async function printPDFS(pdfsToMerge) {
    const mergedPdf = await PDFDocument.create();
    for (const pdfCopyDoc of pdfsToMerge) {
        const pdfBytes = await fetch(pdfCopyDoc).then(res => res.arrayBuffer())
        //const pdfBytes = fs.readFileSync(pdfCopyDoc);
        const pdf = await PDFDocument.load(pdfBytes);
        const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
        copiedPages.forEach((page) => {
            mergedPdf.addPage(page);
        });
    }
    const mergedPdfFile = await mergedPdf.save();
    downloadFile(mergedPdfFile);
}

const useStyles = makeStyles((theme) => ({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      width: 360,
    },
}));

export default withTranslation()(function EnquiryStatus({ t, i18n }) {
    let scroll = Scroll.animateScroll;
    const history = useHistory();
    const lang = i18n.language;
    const { data, setValues } = useData();
    const [ pdfsArr, setPdfsArr ] = useState([]);
    const [ pdfsArr2, setPdfsArr2 ] = useState([]);
    const [ isDeliveryMethodEPermit, setIsDeliveryMethodEPermit ] = useState(false);

    const { status, epas_ref_num, epermit_print_count, pdf_link, epermit_expiry_print_date, permit_language } = data;
    const [ printCount, setPrintCount ] = useState(epermit_print_count);

    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const isNotExpired = !isEmpty(data.epermit_expiry_print_date)&&moment(new Date(data.epermit_expiry_print_date)).diff(moment(), "days")>=0;
    const isNotOutOfPrintCount = !isEmpty(printCount)&&printCount>0;
    const isEpermitAvailable = isDeliveryMethodEPermit&&isNotExpired&&isNotOutOfPrintCount;
    checkIfRedirect(data, history);

    let displayStatus = "";
    if(isEmpty(status)){
        displayStatus = t('enquiryStatus.submitted');
    } else {
        switch (status) {
            case "Submitted":
                displayStatus = t('enquiryStatus.submitted');
                break;
            case "In Progress":
                displayStatus = t('enquiryStatus.inProgress');
                break;
            case "on_hold":
                displayStatus = t('enquiryStatus.onHold');
                break;
            case "Approved":
                displayStatus = t('enquiryStatus.approved');
                break;
            case "Rejected":
            case "CANCELLED":
                displayStatus = t('enquiryStatus.rejected');
                break;
            default:
                displayStatus = t('enquiryStatus.submitted');
                break;
        }
    }

    const handlePrint = () => {
        // if(!isEmpty(pdfsArr)){
        //     printPDFS(pdfsArr);
        //     setPrintCount(printCount-1);
        // }
        if(!isEmpty(pdfsArr)){
            setOpen(true);
            const url = `${window.location.origin}/EPASService/application/reducePrintCount`
            let postOption = {
                method: 'POST',
                body: JSON.stringify({onlineAppNo: data.onlineAppNo, vehicleRegisMark: data.vehicleRegisMark, email: data.email})
            }
            fetch(url, postOption)
            .then((response)=>(response.json()))
		    .then((jsonObj)=>{
                printPDFS(pdfsArr);
                setPrintCount(printCount-1);
                setOpen(false);
            })
            .catch((error)=>{
                console.log('error', error);
                setOpen(false);
            });
        }
    }
    
    const handlePrint2 = () => {
        // if(!isEmpty(pdfsArr)){
        //     printPDFS(pdfsArr);
        //     setPrintCount(printCount-1);
        // }
        // if(!isEmpty(pdfsArr2)){
        //     const url = `${window.location.origin}/EPASService/application/getLetterService`
        //     let postOption = {
        //         method: 'POST',
        //         body: JSON.stringify({refNo: data.onlineAppNo, printLetterType: (permit_language === "English" ? "EL" : "CL")})
        //     }
        //     fetch(url, postOption)
        //     .then((response)=>(response.json()))
		//     .then((jsonObj)=>{
        //         printPDFS(pdfsArr2);
        //     })
        //     .catch(console.log);
        // }
        if(!isEmpty(pdfsArr2)){
            printPDFS(pdfsArr2);
        }
    }

    const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];
      
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);
      
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
      
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
      
        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
      }

    useEffect(() => {
        setOpen(true);
        scroll.scrollToTop();
        let url = `${window.location.origin}/EPASService/application/generatePDF`;
        let postOption = {
            method: 'POST',
            body: JSON.stringify({onlineAppNo: data.onlineAppNo, vehicleRegisMark: data.vehicleRegisMark, email: data.email})
        };
        fetch(url, postOption)
        .then((response)=>(response.json()))
        .then((jsonResponse)=>{
            if(jsonResponse.message==="ok"){
                let temPdfsArr = [];
                jsonResponse.pdf.forEach((pdfContent)=>{
                    const pdfBlob = b64toBlob(pdfContent, "application/pdf");
                    const url = URL.createObjectURL(pdfBlob);
                    temPdfsArr.push(url);
                })
                setPdfsArr(temPdfsArr);
                setIsDeliveryMethodEPermit(true);

                //get letter
                let url2 = `${window.location.origin}/EPASService/application/getLetterService`;
                let postOption2 = {
                    method: 'POST',
                    body: JSON.stringify({onlineAppNo: data.onlineAppNo, vehicleRegisMark: data.vehicleRegisMark, email: data.email, printLetterType: (permit_language === "English" ? "EL" : "CL")})
                };
                fetch(url2, postOption2)
                .then((response)=>(response.json()))
                .then((jsonResponse)=>{
                    if(jsonResponse.message==="ok"){
                        let temPdfsArr = [];
                        console.log("jsonResponse", JSON.parse(jsonResponse.data));
                        //const pdfContent = jsonResponse.data.split('"')[7];
                        const pdfContent = JSON.parse(jsonResponse.data).file;
                        const pdfBlob = b64toBlob(pdfContent, "application/pdf");
                        const url = URL.createObjectURL(pdfBlob);
                        temPdfsArr.push(url);
                        
                        setPdfsArr2(temPdfsArr);
                    }

                    setOpen(false);
                }).catch((error)=>{
                    console.log('error', error);
                    setOpen(false);
                });
            }else{
                setOpen(false);
            }
        }).catch((error)=>{
            console.log('error', error);
            setOpen(false);
        });
    }, []);
    
    console.log("onlineAppNo: ", data.onlineAppNo);
    console.log("epas_ref_num: ", epas_ref_num);
    console.log("URL: ", window.location.origin);
    console.log("Permit Language: ", permit_language);
    
    // Change ref number format 4 groups
    let epas_ref_num1 = epas_ref_num.toString().substring(0,4);
    let epas_ref_num2 = epas_ref_num.toString().substring(4,8);
    let epas_ref_num3 = epas_ref_num.toString().substring(8,12);
    let epas_ref_num4 = epas_ref_num.toString().substring(12,16);
    
    const [dnsData, setDnsData] = useState(null);

    const getDnsData = async () => {
    const response = await fetch(`https://dns.google.com/resolve?name=` + window.location.hostname + `&type=1`);
    const jsonData = await response.json();
        return jsonData;
    };

    useEffect(() => {
        getDnsData().then(data => {
        setDnsData(data);
        }); 
    }, []);

    if (dnsData === null) {
        return null;
    }
    
    const siteID = () => {
        console.log("DNS Status Code: ", dnsData.Status);
        if (dnsData.Status.toString() === "0") {
            if(dnsData.Answer[0].data.toString() === "202.128.244.150") {
                console.log(">>> UAT <<<");
                return "0";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.229.85") {
                console.log(">>> KP Server <<<");
                return "1";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.244.85") {
                console.log(">>> SP Server <<<");
                return "2";
            }
            else if (dnsData.Answer[0].name.toString() === "epas.td.gov.hk.") {
                if (dnsData.Answer[1].data.toString() === "202.128.229.85") {
                    console.log(">>> KP Server <<<");
                    return "1";
                }
                else if (dnsData.Answer[1].data.toString() === "202.128.244.85") {
                    console.log(">>> SP Server <<<");
                    return "2";
                }
            }
        }
        else {
            console.log(">>> Localhost <<<");
            return "0";
        }
    }

    return (
        <main>
            <div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={open}
                >
                    <Fade in={open}>
                    <div className={classes.paper}>
                        <LoadingSpinner />
                        <h2 id="transition-modal-title" className="center">{t('confirmation.modalMessage.download')}</h2>
                        <h2 id="transition-modal-description"  className="center">{t('confirmation.modalMessage.wait')}</h2>
                    </div>
                    </Fade>
                </Modal>
            </div>
            <Helmet>
                <title>{`Screen ID: SC-790-`+siteID()+'-011'}</title>
            </Helmet>
            {/* {(!isEmpty(base64PermitPDF)) && <iframe 
                src={`data:application/pdf;base64,${base64PermitPDF}`} id='permitPDF' 
                frameBorder='0'
        		width='300' height='300'></iframe>} */}
            <Box className="wrapper enquiryStatus">
                <Header langLock="langLocked" />
                <Box className="mainWrapper">
                    <Navbar noStep />
                    <Box className="contentWrapper">
                        <form noValidate>
                            <FormBox header="enquiryStatus.title">
                                <Box p={5}>
                                    <Box mb={6}>
                                        <Typography variant="body1">
                                            {t('enquiryStatus.refNum')}
                                        </Typography>
                                        <Typography variant="body1" className="bold">
                                            {epas_ref_num1 + " " + epas_ref_num2 + " " + epas_ref_num3 + " " + epas_ref_num4}
                                        </Typography>
                                    </Box>
                                    <Box mb={6}>
                                        <Typography variant="body1">
                                            {t('enquiryStatus.status')}
                                        </Typography>
                                        <Typography variant="body1" className="bold">
                                            {displayStatus}
                                        </Typography>
                                    </Box>
                                    { status=="Approved"&&isDeliveryMethodEPermit&&
                                    <>
                                    <Box mb={6}>
                                        <Typography variant="body1">
                                            {t('enquiryStatus.eLetter')}
                                        </Typography>
                                        <Button onClick={(isNotExpired)?handlePrint2:()=>{}} disabled={!isNotExpired}>
                                            <Typography variant="body1" className="bold red">
                                                {t('enquiryStatus.clickToPrint')}
                                                {(!isNotExpired&&t('enquiryStatus.expired'))}
                                            </Typography>
                                        </Button>
                                    </Box>
                                    <Box mb={6}>
                                        <Typography variant="body1">
                                            {t('enquiryStatus.ePermit')}
                                        </Typography>
                                        <Button onClick={(isNotExpired&&isNotOutOfPrintCount)?handlePrint:()=>{}} disabled={!isNotExpired||!isNotOutOfPrintCount}>
                                            <Typography variant="body1" className="bold red">
                                                {t('enquiryStatus.clickToPrint')}
                                                {(!isNotOutOfPrintCount&&t('enquiryStatus.outOfPrintCount'))||(!isNotExpired&&t('enquiryStatus.expired'))}
                                            </Typography>
                                        </Button>
                                    </Box>
                                    <Box mb={6}>
                                        <Typography variant="body1">
                                            {t('enquiryStatus.ePermitDeadline')}
                                        </Typography>
                                        <Typography variant="body1" className="bold">
                                            {moment(new Date(epermit_expiry_print_date)).format("YYYY-MM-DD")}
                                        </Typography>
                                    </Box>
                                    <Box mb={6}>
                                        <Typography variant="body1">
                                            {t('enquiryStatus.numRetries')}
                                        </Typography>
                                        <Typography variant="body1" className={(!isNotExpired&&"uppercase")+" bold disabled"}>
                                            {printCount}{(!isNotExpired&&t('enquiryStatus.expired'))}
                                        </Typography>
                                    </Box>
                                    </>
                                    }
                                </Box>
                            </FormBox>
                            {isDeliveryMethodEPermit&&
                            <FormBox>
                                <Box 
                                    p={5}
                                    bgcolor="tnc.secondary"
                                >
                                    <ol>
                                        <li>{t('enquiryStatus.notesMsg1')}</li>
                                        <li>{t('enquiryStatus.notesMsg2')}</li>
                                        <li>{t('enquiryStatus.notesMsg3')}</li>
                                        <ul>
                                            <li>{t('enquiryStatus.notesMsg3_1')}</li>
                                            <li>{t('enquiryStatus.notesMsg3_2')}</li>
                                            <li>{t('enquiryStatus.notesMsg3_3')}</li>
                                        </ul>
                                        <li>{t('enquiryStatus.notesMsg4')}</li>
                                        <li>{t('enquiryStatus.notesMsg5')}</li>
                                    </ol>
                                </Box>
                            </FormBox>
                            }
                            <FormBox>
                                <Box
                                    display="flex" 
                                    justifyContent="flex-end"
                                >
                                    <Button 
                                        variant="contained" 
                                        color="secondary"
                                        onClick={() => history.push(`${process.env.REACT_APP_SUB_ROUTE}/selectService`)}
                                    >
                                        {t('common.button.back')}
                                    </Button>
                                </Box>
                            </FormBox>
                        </form>
                    </Box>
                </Box>
            </Box>
            <Footer />
        </main>
    )
})
